// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"94":"Login","138":"profile","594":"demo"}[chunkId] + "." + {"94":"7a9644a4","138":"d0a670aa","594":"d41676dd"}[chunkId] + ".css";
};